import { FIRST_LETTER_SURNAME } from 'Data/common-constants.js'
import View from './view.js'
import React from 'react'

// TODO check if list can be referenced from a file
export default function Logic(props) {
  return <View from={FIRST_LETTER_SURNAME} viewPath={props.viewPath} />
}
